import { render } from "./CRommeMastersHeader.vue?vue&type=template&id=77421076&scoped=true"
const script = {}

import "./CRommeMastersHeader.vue?vue&type=style&index=0&id=77421076&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77421076"]])

export default __exports__